import { metrics, ValueType } from '@opentelemetry/api';

const meter = metrics.getMeter('ui-datapro');

export const careGoals503Counter = meter.createCounter('garnerhealth_care_goals_503', {
  valueType: ValueType.INT,
  description: 'Clinical attributes care goals endpoint returned a 503 Service Unavailable response.',
});
